import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopuneinnovacrysta() {



  const cardData =
  {
    keyword: ' Mumbai to Pune Innova Crysta Cab',
    heading: 'Sai Trupti Cabs: Mumbai to Pune Innova Crysta Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Mumbai to Pune Innova Crysta cab services, designed to provide a premium and stress-free travel experience. Our fleet features well-maintained, air-conditioned Toyota Innova Crysta vehicles — all equipped with spacious interiors, plush reclining seats, and ample luggage space for families and groups. Every trip is handled by a professional, background-verified chauffeur who ensures punctual pickup from any location in Mumbai, courteous service, and safe, smooth driving throughout the journey to Pune. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Mumbai to Pune in an Innova Crysta convenient, luxurious, and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Mumbai to Pune Innova Crysta Cab",
      "description": "Premium Innova Crysta cab service from Mumbai to Pune offering spacious seating, luxurious interiors, AC service, professional drivers, luggage assistance, flexible pickup and drop points, real-time tracking, and transparent fares. Ideal for family trips, corporate travel, VIP transport, and long-distance comfort ensuring a safe, smooth, and stress-free journey."
    },
    {
      "name": "Mumbai to Pune Innova Cab",
      "description": "Reliable Innova cab service from Mumbai to Pune featuring AC and non-AC options, professional drivers, luggage support, well-maintained vehicles, flexible pickup and drop locations, real-time tracking, and transparent fares. Perfect for family outings, group travel, corporate commuters, and weekend trips for a comfortable, safe, and convenient ride."
    },
    {
      "name": "Mumbai to Pune AC Cab",
      "description": "AC cab service from Mumbai to Pune providing cool, comfortable, and safe travel for solo travelers, families, and corporate clients. Includes professional drivers, luggage assistance, flexible schedules, real-time tracking, multiple vehicle options, and transparent fares to ensure a stress-free and reliable journey."
    },
    {
      "name": "Mumbai to Pune Luxury Innova Cab",
      "description": "Luxury Innova cab service from Mumbai to Pune offering premium interiors, spacious seating, AC service, professional chauffeurs, luggage assistance, flexible pickup and drop, real-time tracking, and transparent fares. Ideal for executives, VIP travelers, family trips, or special occasions requiring high-end comfort and style."
    },
    {
      "name": "Mumbai to Pune Sedan Cab",
      "description": "Sedan cab service from Mumbai to Pune providing smooth and comfortable rides for solo travelers, couples, or small families. Features AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares for business travel, city commutes, and weekend trips."
    },
    {
      "name": "Mumbai to Pune One Way Innova Cab",
      "description": "Affordable one-way Innova cab service from Mumbai to Pune for direct, efficient, and hassle-free travel. Includes AC/non-AC options, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares. Suitable for tourists, corporate commuters, and families seeking safe, reliable transportation."
    },
    {
      "name": "Mumbai to Pune Drop Cab",
      "description": "Drop cab service from Mumbai to Pune providing point-to-point travel with AC and non-AC options, professional drivers, luggage assistance, flexible pickup/drop locations, well-maintained vehicles, real-time tracking, and transparent fares. Perfect for daily commuters, corporate travelers, and leisure trips ensuring convenient and stress-free transport."
    },
    {
      "name": "Mumbai to Pune Outstation Cab",
      "description": "Outstation cab service from Mumbai to Pune with long-distance travel comforts including AC/non-AC vehicles, professional drivers, luggage support, toll coverage, flexible schedules, online booking, real-time tracking, and transparent fares. Ideal for weekend getaways, corporate travel, family trips, and extended travel with comfort and safety."
    },
    {
      "name": "Affordable Mumbai to Pune Innova Cab",
      "description": "Budget-friendly Innova cab service from Mumbai to Pune offering cost-effective travel with AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and transparent fares. Perfect for families, students, tourists, and corporate clients looking for reliable yet economical transportation."
    },
    {
      "name": "Mumbai to Pune Online Booking",
      "description": "Book your Mumbai to Pune cab online instantly with multiple vehicle options including Innova, Sedan, and luxury cars. Features secure payments, real-time tracking, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop locations, and transparent fares for convenient, safe, and hassle-free travel."
    },
    {
      "name": "Mumbai to Pune Corporate Cab",
      "description": "Corporate cab service from Mumbai to Pune with professional drivers, AC vehicles, luggage assistance, flexible schedules, real-time tracking, and transparent fares. Perfect for business executives, office commuters, and corporate teams seeking reliable, comfortable, and efficient transport."
    },
    {
      "name": "Mumbai to Pune Wedding Cab",
      "description": "Special wedding cab service from Mumbai to Pune offering luxury Innova and premium cars with spacious seating, AC service, professional chauffeurs, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares. Ideal for wedding parties, family events, and special occasions ensuring comfort and elegance."
    },
    {
      "name": "Mumbai to Pune Ertiga Cab",
      "description": "Ertiga cab service from Mumbai to Pune providing comfortable seating for groups, AC/non-AC options, luggage assistance, professional drivers, flexible pickup/drop locations, real-time tracking, and transparent fares. Suitable for family trips, group outings, corporate travel, and long-distance journeys with safety and convenience."
    },
    {
      "name": "Mumbai to Pune Taxi Service",
      "description": "Reliable taxi service from Mumbai to Pune with AC/non-AC options, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares. Ideal for daily commuters, tourists, families, and corporate travelers seeking safe, comfortable, and efficient transport."
    },
    {
      "name": "Mumbai to Pune Cab Near Me",
      "description": "Find Mumbai to Pune cabs near your location for quick, convenient, and hassle-free booking. Includes AC and non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, transparent fares, and well-maintained vehicles ensuring reliable and comfortable travel."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Innova Crysta Cab", "Mumbai to Pune Innova Cab"],
    ["Mumbai to Pune AC Cab", "Mumbai to Pune Luxury Innova Cab"],
    ["Mumbai to Pune Sedan Cab", "Mumbai to Pune One Way Innova Cab"],
    ["Mumbai to Pune Drop Cab", "Mumbai to Pune Outstation Cab"],
    ["Affordable Mumbai to Pune Innova Cab", "Mumbai to Pune Online Booking"],
    ["Mumbai to Pune Corporate Cab", "Mumbai to Pune Wedding Cab"],
    ["Mumbai to Pune Ertiga Cab", "Mumbai to Pune Taxi Service"],
    ["Mumbai to Pune Cab Near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Pune Innova Crysta Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers premium and comfortable Innova Crysta cab services from Mumbai to Pune — ideal for family travel, business trips, or long-distance journeys."
  },
  {
    "WhyChooseheading": "Spacious & Luxurious Travel Experience",
    "WhyChoosedescription": "The Toyota Innova Crysta provides ample legroom, superior comfort, and modern interiors, making it perfect for groups or families traveling between Mumbai and Pune."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our Mumbai to Pune Innova Crysta cab fares start from approximately ₹3,000–₹3,700 (one-way), inclusive of driver allowance, tolls, and state taxes — with no hidden costs."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers ensure a safe, smooth, and punctual journey on the Mumbai–Pune Expressway, prioritizing your comfort and safety."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Options",
    "WhyChoosedescription": "Enjoy flexible pickup from any Mumbai location — airport, hotel, or residence — and convenient drop-offs anywhere in Pune as per your travel needs."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Innova Crystas",
    "WhyChoosedescription": "Each Innova Crysta is regularly serviced, sanitized, and maintained to deliver a reliable and premium inter-city travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available 24×7 to assist with bookings, itinerary customization, and route planning for your Mumbai to Pune cab trip."
  },
  {
    "WhyChooseheading": "Easy & Hassle-Free Booking",
    "WhyChoosedescription": "Book your Mumbai to Pune Innova Crysta cab via call, WhatsApp, or our website — with instant booking confirmation and prompt cab dispatch."
  }
]








  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Mumbai to Pune Innova Crysta cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and comfortable Mumbai to Pune Innova Crysta cab services for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Mumbai to Pune Innova Crysta cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Mumbai to Pune Innova Crysta cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'Are the drivers experienced for Mumbai to Pune Innova Crysta trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey in the Innova Crysta.',
  },
  {
    question: 'Can I hire an Innova Crysta cab from Mumbai to Pune for corporate or personal travel?',
    answer: 'Certainly. Our Innova Crysta cab services cater to corporate clients, airport transfers, family trips, and leisure travel between Mumbai and Pune.',
  },
  {
    question: 'Is the Mumbai to Pune Innova Crysta cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Innova Crysta cab services for Mumbai to Pune trips for maximum convenience and travel flexibility.',
  },
  {
    question: 'What are the Mumbai to Pune Innova Crysta cab fares?',
    answer: 'Our fares for Mumbai to Pune Innova Crysta start from approximately ₹2,500–₹3,500 depending on distance, travel requirements, and trip type.',
  },
  {
    question: 'What payment options are accepted for Mumbai to Pune Innova Crysta cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai to Pune Innova Crysta cabs?',
    answer: 'All Innova Crysta vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Mumbai to Pune Innova Crysta cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Mumbai to Pune Innova Crysta cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Booking an Innova Crysta from Mumbai to Pune with Sai Trupti Cabs was seamless. The vehicle was clean and the driver very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent Innova Crysta service from Mumbai to Pune. Comfortable ride and courteous driver.',
    rating: 5,
  },
];











































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Innova Crysta Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Mumbai to Pune Innova Crysta Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-to-pune-innova-crysta-cab"
  }
};






  return (
    <div>
      <Helmet>
  <title>Mumbai to Pune Innova Crysta Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune Innova Crysta Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Innova Crysta Cab, Mumbai to Pune Innova Cab, Mumbai to Pune AC Cab, Mumbai to Pune Luxury Innova Cab, Mumbai to Pune Sedan Cab, Mumbai to Pune One Way Innova Cab, Mumbai to Pune Drop Cab, Mumbai to Pune Outstation Cab, Affordable Mumbai to Pune Innova Cab, Mumbai to Pune Online Booking, Mumbai to Pune Corporate Cab, Mumbai to Pune Wedding Cab, Mumbai to Pune Ertiga Cab, Mumbai to Pune Taxi Service, Mumbai to Pune Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopuneinnovacrysta;